
import { Attachment } from '../types/attachment';

// Sample mock data for demonstration
export const MOCK_ATTACHMENTS: Attachment[] = [
  {
    id: '1',
    fileName: 'Project_Report.pdf',
    fileType: 'pdf',
    fileSize: 2500000, // 2.5MB
    emailSubject: 'Q3 Project Report',
    emailSender: 'manager@company.com',
    emailSenderName: 'Jane Manager',
    emailDate: '2023-10-15T10:30:00Z',
    emailId: 'msg1',
    emailRecipients: ['you@example.com'],
    downloadUrl: '/api/attachments/1/download'
  },
  {
    id: '2',
    fileName: 'Conference_Schedule.docx',
    fileType: 'docx',
    fileSize: 1200000, // 1.2MB
    emailSubject: 'Upcoming Conference Details',
    emailSender: 'events@company.com',
    emailSenderName: 'Events Team',
    emailDate: '2023-10-12T14:15:00Z',
    emailId: 'msg2',
    emailRecipients: ['you@example.com', 'team@example.com'],
    downloadUrl: '/api/attachments/2/download'
  },
  {
    id: '3',
    fileName: 'Product_Photo.jpg',
    fileType: 'jpg',
    fileSize: 3800000, // 3.8MB
    emailSubject: 'New Product Images',
    emailSender: 'marketing@company.com',
    emailSenderName: 'Marketing Department',
    emailDate: '2023-10-10T09:45:00Z',
    emailId: 'msg3',
    emailRecipients: ['you@example.com'],
    downloadUrl: '/api/attachments/3/download'
  },
  {
    id: '4',
    fileName: 'Financial_Statement.xlsx',
    fileType: 'xlsx',
    fileSize: 1800000, // 1.8MB
    emailSubject: 'September Financial Statement',
    emailSender: 'finance@company.com',
    emailSenderName: 'Finance Team',
    emailDate: '2023-10-08T16:20:00Z',
    emailId: 'msg4',
    emailRecipients: ['you@example.com', 'accounting@example.com'],
    downloadUrl: '/api/attachments/4/download'
  },
  {
    id: '5',
    fileName: 'Client_Presentation.pptx',
    fileType: 'pptx',
    fileSize: 5500000, // 5.5MB
    emailSubject: 'Client Meeting Presentation',
    emailSender: 'sales@company.com',
    emailSenderName: 'Sales Department',
    emailDate: '2023-10-05T11:00:00Z',
    emailId: 'msg5',
    emailRecipients: ['you@example.com', 'client@othercompany.com'],
    downloadUrl: '/api/attachments/5/download'
  },
  {
    id: '6',
    fileName: 'System_Architecture.pdf',
    fileType: 'pdf',
    fileSize: 4200000, // 4.2MB
    emailSubject: 'System Architecture Documentation',
    emailSender: 'tech@company.com',
    emailSenderName: 'Tech Team',
    emailDate: '2023-10-03T13:40:00Z',
    emailId: 'msg6',
    emailRecipients: ['you@example.com', 'developers@example.com'],
    downloadUrl: '/api/attachments/6/download'
  },
  {
    id: '7',
    fileName: 'Team_Photo.png',
    fileType: 'png',
    fileSize: 7000000, // 7MB
    emailSubject: 'Company Retreat Photos',
    emailSender: 'hr@company.com',
    emailSenderName: 'HR Department',
    emailDate: '2023-09-28T15:50:00Z',
    emailId: 'msg7',
    emailRecipients: ['all-staff@example.com'],
    downloadUrl: '/api/attachments/7/download'
  },
  {
    id: '8',
    fileName: 'User_Manual.pdf',
    fileType: 'pdf',
    fileSize: 3100000, // 3.1MB
    emailSubject: 'Updated User Manual',
    emailSender: 'support@company.com',
    emailSenderName: 'Support Team',
    emailDate: '2023-09-25T10:10:00Z',
    emailId: 'msg8',
    emailRecipients: ['you@example.com', 'users@example.com'],
    downloadUrl: '/api/attachments/8/download'
  },
  {
    id: '9',
    fileName: 'Company_Podcast.mp3',
    fileType: 'mp3',
    fileSize: 15800000, // 15.8MB
    emailSubject: 'Latest Company Podcast Episode',
    emailSender: 'media@company.com',
    emailSenderName: 'Media Team',
    emailDate: '2023-09-20T09:30:00Z',
    emailId: 'msg9',
    emailRecipients: ['all-staff@example.com'],
    downloadUrl: '/api/attachments/9/download'
  },
  {
    id: '10',
    fileName: 'Product_Demo.mp4',
    fileType: 'mp4',
    fileSize: 45600000, // 45.6MB
    emailSubject: 'New Product Demo Video',
    emailSender: 'product@company.com',
    emailSenderName: 'Product Team',
    emailDate: '2023-09-18T14:45:00Z',
    emailId: 'msg10',
    emailRecipients: ['you@example.com', 'team@example.com'],
    downloadUrl: '/api/attachments/10/download'
  },
  {
    id: '11',
    fileName: 'Conference_Call.wav',
    fileType: 'wav',
    fileSize: 24200000, // 24.2MB
    emailSubject: 'Recorded Conference Call',
    emailSender: 'meetings@company.com',
    emailSenderName: 'Meetings Coordinator',
    emailDate: '2023-09-15T11:15:00Z',
    emailId: 'msg11',
    emailRecipients: ['you@example.com', 'participants@example.com'],
    downloadUrl: '/api/attachments/11/download'
  },
  {
    id: '12',
    fileName: 'Training_Video.mp4',
    fileType: 'mp4',
    fileSize: 78300000, // 78.3MB
    emailSubject: 'New Employee Training Video',
    emailSender: 'training@company.com',
    emailSenderName: 'Training Department',
    emailDate: '2023-09-12T13:20:00Z',
    emailId: 'msg12',
    emailRecipients: ['new-hires@example.com'],
    downloadUrl: '/api/attachments/12/download'
  },
];
